import { GridApiPro } from '@mui/x-data-grid-pro';
import { MutableRefObject, useCallback, useEffect, useState } from 'react';

export const useHasScrollUp = (apiRef?: MutableRefObject<GridApiPro>) => {
  const [showScrollToTop, setShowScrollToTop] = useState(false);

  const handleScrollToTop = useCallback(() => {
    if (apiRef?.current) {
      const virtualScroller = document.querySelector('.MuiDataGrid-virtualScroller');
      if (virtualScroller) {
        virtualScroller.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      }
    }
  }, [apiRef]);

  useEffect(() => {
    if (!apiRef?.current) {
      return;
    }

    const handleScroll = () => {
      const virtualScroller = document.querySelector('.MuiDataGrid-virtualScroller') as HTMLElement;
      if (virtualScroller) {
        const scrollTop = virtualScroller.scrollTop;
        setShowScrollToTop(scrollTop > 0);
      }
    };

    const unsubscribe = apiRef.current.subscribeEvent('scrollPositionChange', handleScroll);

    handleScroll();

    return unsubscribe;
  }, [apiRef]);

  return { handleScrollToTop, showScrollToTop };
};
